import React, {Fragment} from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import {FormattedMessage, injectIntl} from "react-intl";

import {cartItemInterface} from "../cartItemInterface";
import {getFeatureIsLocked, toFixedFeatureCost} from "../../../misc/helpers";
import {toggleUserPopup} from "../../../actions/actionFunctions";
import {SQFT_FEATURES} from "../../sqft/constants";
import {getPriceWithIncluded, getShowPrice} from "../../../misc/priceFunctions";

const CartItemTotal = (props) => {

  const {cartItem, fabricatorData, toggleUserPopup, intl} = props;
  let priceTotal = 0;

  let showPrice = false;
  let priceIsLocked = false;
  if (!cartItem.isEmpty) {
    priceIsLocked = getFeatureIsLocked(cartItem.cartFeature);
    if (getShowPrice(fabricatorData) && !priceIsLocked) {
      showPrice = true;
      if (cartItem.displayFakePrice !== 0) {
        priceTotal = toFixedFeatureCost(cartItem.cartFeature, cartItem.quantity, cartItem.fromQtCategory, true, cartItem, cartItem.partId === SQFT_FEATURES.slabs);
      }
    }
  }

  if (cartItem.partId === "room" && !priceTotal) {
    return <div className="aq-cell aq-cell--total"/>
  }

  return (
    <div className="aq-cell aq-cell--total">
      {showPrice ? (
        <Fragment>
          <div className="aq-title"><FormattedMessage id="advancedQuoting.itemTotal"/></div>
          <span className="aq-price">
            {getPriceWithIncluded(priceTotal, cartItem.cartFeature, fabricatorData, intl.messages)}
          </span>
        </Fragment>
      ) : null}
      {priceIsLocked ? (
        <span className="price price--locked" onClick={() => toggleUserPopup({ userPopupOpened: true })}>
          <FormattedMessage id="shoppingCart.featureInCartPricingLocked"/>
        </span>
      ) : null}
    </div>
  )
};

CartItemTotal.propTypes = {
  cartItem: PropTypes.shape(cartItemInterface),
};

const mapStateToProps = (store, ownProps) => {
  const {cartItems} = store.cartState;
  const {showAssignQuotePopup} = store.assignQuoteState;
  return {
    fabricatorData: store.fabricatorState,
    quantity: ownProps.cartItem.quantity,
    cartItems, // we need to update price on other cart items change
    showAssignQuotePopup,
  };
};

const mapDispatchToProps = {
  toggleUserPopup
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(
    React.memo(CartItemTotal, (props, nextProps)=> {
      // if (props.showAssignQuotePopup === nextProps.prop1) {
      if (nextProps.showAssignQuotePopup) {
        // don't re-render/update
        return true
      }
    })
  )
)
